import type { ReactNode } from "react";

import { useBrandLogo } from "@/hooks/useBrandLogo";

interface BrandLogoProps {
  /** Sizing classes for the uploaded logo image (e.g. "h-8 w-auto"). */
  className?: string;
  /** Accessible name. Ignored when `decorative` is set. */
  alt?: string;
  /** True when a nearby element already carries the accessible name. */
  decorative?: boolean;
  /** Built-in wordmark rendered when no logo is configured. */
  children: ReactNode;
}

/**
 * Renders the admin-uploaded PODGO logo, falling back to the built-in
 * wordmark/artwork passed as children. Single swap point for every header,
 * footer and marketing logo spot.
 */
export function BrandLogo({ className, alt = "PODGO", decorative, children }: BrandLogoProps) {
  const { data: logoUrl } = useBrandLogo();

  if (!logoUrl) return <>{children}</>;

  return (
    <img
      src={logoUrl}
      alt={decorative ? "" : alt}
      aria-hidden={decorative || undefined}
      className={className}
    />
  );
}
